/* eslint-disable @typescript-eslint/no-explicit-any */ import { SWStoreSchemaImpl } from "@supersig/store";
import { createIntegrityChecker, onValidationFailure } from "./SWStore";
import { LocalizationProviderMap } from "./localizationProviders";
import { productMap } from "./products";
import { AssetRecordType, SWPaywallLanguageRecordType, SWPaywallRecordType, SWPaywallSurveyRecordType, createLocalizationProviderInfoRecordType, createLocalizationProviderLanguageRecordType, createLocalizationProviderRecordType, createProductRecordType, createShapeRecordType } from "./records";
import { DocumentRecordType } from "./records/SWDocument";
import { createInstanceRecordType } from "./records/SWInstance";
import { createLoadableRecordType } from "./records/SWLoadable";
import { createNodeRecordType } from "./records/SWNode";
import { SWNodePropertyRecordType } from "./records/SWNodeProperty";
import { SWInstancePageStateRecordType } from "./records/SWPageState";
import { SWPaywallNotificationRecordType } from "./records/SWPaywallNotification";
import { SWPaywallProductRecordType } from "./records/SWPaywallProduct";
import { createProductDetailRecordType } from "./records/SWProductDetail";
import { createResourceRecordType } from "./records/SWResource";
import { createResourceVariantRecordType } from "./records/SWResourceVariant";
import { createResourceVariantStoredRecordType } from "./records/SWResourceVariantStored";
import { createResourceVersionSeenRecordType } from "./records/SWResourceVersionSeen";
import { SWStateRecordType } from "./records/SWState";
import { SWStateValueRecordType } from "./records/SWStateValue";
import { SWStyleVariableGroupRecordType } from "./records/SWStyleVariableGroup";
import { CameraRecordType } from "./records/TLCamera";
import { PageRecordType } from "./records/TLPage";
import { PointerRecordType } from "./records/TLPointer";
import { InstancePresenceRecordType } from "./records/TLPresence";
import { ResourceMap } from "./resources/ResourceMap";
import { storeMigrations } from "./store-migrations";
/**
 * Create a SWSchema with custom nodes and loadables.
 *
 * @param opts - Options
 *
 * @public */ export function createSWSchema({ nodes, loadables }) {
    const stylesById = new Map();
    const ShapeRecordType = createShapeRecordType({});
    const InstanceRecordType = createInstanceRecordType(stylesById);
    const NodeRecordType = createNodeRecordType(nodes);
    const SWResourceRecordType = createResourceRecordType(ResourceMap);
    const SWResourceVariantRecordType = createResourceVariantRecordType(ResourceMap);
    const SWResourceVersionSeenRecordType = createResourceVersionSeenRecordType(ResourceMap);
    const SWResourceVariantStoredRecordType = createResourceVariantStoredRecordType(ResourceMap);
    const LocalizationProviderRecordType = createLocalizationProviderRecordType(LocalizationProviderMap);
    const SWLocalizationProviderLanguageRecordType = createLocalizationProviderLanguageRecordType(Object.keys(LocalizationProviderMap).reduce((acc, key)=>({
            ...acc,
            [key]: {}
        }), {}));
    const SWLocalizationProviderInfoRecordType = createLocalizationProviderInfoRecordType(Object.keys(LocalizationProviderMap).reduce((acc, key)=>({
            ...acc,
            [key]: {}
        }), {}));
    const SWLoadableRecordType = createLoadableRecordType(loadables);
    const SWProductType = createProductRecordType(productMap);
    const SWProductDetailType = createProductDetailRecordType(productMap);
    return SWStoreSchemaImpl.create({
        asset: AssetRecordType,
        camera: CameraRecordType,
        document: DocumentRecordType,
        instance: InstanceRecordType,
        instance_page_state: SWInstancePageStateRecordType,
        page: PageRecordType,
        resource: SWResourceRecordType,
        resource_variant: SWResourceVariantRecordType,
        resource_version_seen: SWResourceVersionSeenRecordType,
        shape: ShapeRecordType,
        resource_variant_stored: SWResourceVariantStoredRecordType,
        instance_presence: InstancePresenceRecordType,
        loadable: SWLoadableRecordType,
        localization_provider: LocalizationProviderRecordType,
        localization_provider_language: SWLocalizationProviderLanguageRecordType,
        localization_provider_info: SWLocalizationProviderInfoRecordType,
        paywall: SWPaywallRecordType,
        paywall_language: SWPaywallLanguageRecordType,
        paywall_notification: SWPaywallNotificationRecordType,
        paywall_product: SWPaywallProductRecordType,
        paywall_survey: SWPaywallSurveyRecordType,
        product: SWProductType,
        product_detail: SWProductDetailType,
        pointer: PointerRecordType,
        node: NodeRecordType,
        node_property: SWNodePropertyRecordType,
        state: SWStateRecordType,
        state_value: SWStateValueRecordType,
        style_variable_group: SWStyleVariableGroupRecordType
    }, {
        snapshotMigrations: storeMigrations,
        // @ts-ignore
        onValidationFailure,
        // Marked as internal but we can still use it
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        createIntegrityChecker: createIntegrityChecker
    });
}
